import { useState, useEffect } from 'react';
import posts from '@/shared/api/posts';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const APITestPage = () => {
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(null);
    const [error, setError] = useState(null);

    const testAPI = async () => {
        setLoading(true);
        setError(null);
        setResult(null);

        try {
            console.log('Testing API connection...');
            const response = await posts.getPublishedPosts(1, 5);
            console.log('API Response:', response);
            setResult(response);
        } catch (err) {
            console.error('API Error:', err);
            setError(err.message || err.toString());
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ padding: '20px', maxWidth: '800px' }}>
            <h1>API Test Page</h1>
            <p>Эта страница для проверки работы API статей</p>

            <div className="mb-4">
                <Button onClick={testAPI} disabled={loading}>
                    {loading ? 'Тестирование...' : 'Проверить API'}
                </Button>
            </div>

            {error && (
                <Card className="mb-4 border-red-200">
                    <CardHeader>
                        <CardTitle className="text-red-600">Ошибка API</CardTitle>
                    </CardHeader>
                    <CardContent>
                        <pre className="bg-red-50 p-4 rounded text-sm">
                            {error}
                        </pre>
                    </CardContent>
                </Card>
            )}

            {result && (
                <Card>
                    <CardHeader>
                        <CardTitle>Результат API</CardTitle>
                    </CardHeader>
                    <CardContent>
                        <div className="space-y-2">
                            <p><strong>Статус:</strong> ✅ Успешно</p>
                            <p><strong>Статей найдено:</strong> {result.posts?.length || 0}</p>
                            <p><strong>Всего страниц:</strong> {result.totalPages || 'N/A'}</p>
                            <p><strong>Текущая страница:</strong> {result.currentPage || 1}</p>
                            
                            {result.posts && result.posts.length > 0 && (
                                <div className="mt-4">
                                    <h4 className="font-medium mb-2">Найденные статьи:</h4>
                                    <div className="space-y-2">
                                        {result.posts.map((post, index) => (
                                            <div key={index} className="p-3 border rounded">
                                                <p><strong>Название:</strong> {post.title}</p>
                                                <p><strong>Slug:</strong> {post.slug}</p>
                                                <p><strong>URL:</strong> /article/{post.slug}</p>
                                                <p><strong>Создана:</strong> {new Date(post.createdAt).toLocaleString()}</p>
                                                <p><strong>Опубликовано:</strong> {post.published ? '✅ Да' : '❌ Нет'}</p>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                        
                        <details className="mt-4">
                            <summary>Полный ответ API</summary>
                            <pre className="bg-gray-50 p-4 rounded text-xs overflow-auto mt-2">
                                {JSON.stringify(result, null, 2)}
                            </pre>
                        </details>
                    </CardContent>
                </Card>
            )}
        </div>
    );
};

export default APITestPage;
